import { render } from "./CartViewEditData.vue?vue&type=template&id=c3a82b2e&ts=true"
import script from "./CartViewEditData.vue?vue&type=script&lang=ts"
export * from "./CartViewEditData.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__